// import gsap from "gsap";
// import { ScrollToPlugin } from "gsap/ScrollToPlugin";
// gsap.registerPlugin(ScrollToPlugin);

// Detects a URL query and jumps to the section, then opens modal and plays video
document.addEventListener('DOMContentLoaded', () => {
  const params = new URLSearchParams(window.location.search);

  for (const [key, value] of params.entries()) {
    if (document.getElementById(key)) {
      location.hash = '#' + key;
    }

    setTimeout(() => {
      const accordion = document.getElementById(key);
      if (accordion && value) {
        const blocks = accordion.querySelectorAll('.video-block');
        let found = false;
        blocks.forEach(block => {
          const blockDeeplink = (block.dataset.videoDeeplink || '').trim();
          console.log('Comparing:', blockDeeplink, 'with', value.trim());
          if (blockDeeplink === value.trim()) {
            block.classList.add('active');
            found = true;
            console.log('Added .active to block:', block);
            // Open modal and play video
            const player = block.querySelector('.video-player');
            if (player) {
              player.click();
              const video = player.querySelector('video');
              if (video) {
                video.click();
              }
            }
          } else {
            block.classList.remove('active');
          }
        });
        if (!found) {
          console.log('No matching .video-block found for:', value.trim());
        }
      }
    }, 300);
  }
});